import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  BarChartOutlined,
  UserOutlined,
  UserAddOutlined,
  MedicineBoxOutlined,
  AppstoreAddOutlined,
  SafetyCertificateFilled,
  EnvironmentOutlined,
  CompassOutlined,
  SettingOutlined,
  LineChartOutlined,
  MenuOutlined,
  MailOutlined,
  DatabaseOutlined,
} from "@ant-design/icons";

import {
  Row,
  Col,
  ConfigProvider,
  Flex,
  Layout,
  Menu,
  theme,
  Button,
  Typography,
  Drawer,
} from "antd";

import { useLocation, useNavigate } from "react-router-dom";
import MyLogo from "../photos/aqib-logo-.png";
import sideNavLogo from "../photos/aqib-logo.png";
import "./Defaulit.css";
import { _get } from "../views/services/service_api";
import {
  API_BASE_URL,
  Roles_list,
  directToken,
} from "../views/services/end_points";
const { Header, Content, Sider } = Layout;

const DefaultLayout = ({ children }) => {
  const [filteredRoutes, setFilteredRoutes] = useState([]);
  const [dataOfUser, setDataOfUser] = useState([]);
  const [selectedKey, setSelectedKey] = useState(window.location.pathname);
  const navigate = useNavigate();
  const location = useLocation();
  const Names = localStorage.getItem("username");
  // const [isAdmin, setIsAdmin] = useState(false);
  const userId = localStorage.getItem("userid");
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const contentRef = useRef(null);
  const [rolesData, setRolesData] = useState();
  const [contentHeight, setContentHeight] = useState("auto");
  const AllRoutes = [
    {
      key: "dashbord",
      label: "Dashboard",
      path: "/dashboard",
      icon: <BarChartOutlined style={{ fontSize: "20px" }} />,
    },
    {
      key: "appointment",
      label: "Appointments",
      path: "/appoimnet-list",
      icon: <MailOutlined style={{ fontSize: "20px" }} />,
    },
    {
      key: "Report",
      label: "Report",
      path: "/report-list",
      icon: <LineChartOutlined style={{ fontSize: "20px" }} />,
    },
    {
      key: "userManagement",
      label: "Users",
      path: "/user-list",
      icon: <UserOutlined style={{ fontSize: "20px" }} />,
    },
    {
      key: "dataManagement",
      label: "Data Management",
      icon: <DatabaseOutlined style={{ fontSize: "20px" }} />,
    },
    {
      key: "hospital",
      label: "Hospital",
      path: "/Hospital-List",
      icon: (
        <MedicineBoxOutlined style={{ marginLeft: "1rem", fontSize: "20px" }} />
      ),
    },
    {
      key: "speciality",
      label: "Speciality",
      path: "/Speciality-List",
      icon: (
        <AppstoreAddOutlined style={{ marginLeft: "1rem", fontSize: "20px" }} />
      ),
    },
    {
      key: "assignSpeciality",
      label: "Assign  Speciality",
      path: "/Master-speciality-list",
      icon: (
        <SafetyCertificateFilled
          style={{ marginLeft: "1rem", fontSize: "20px" }}
        />
      ),
    },
    {
      key: "city",
      label: "City",
      path: "/city-List",
      icon: (
        <EnvironmentOutlined style={{ marginLeft: "1rem", fontSize: "20px" }} />
      ),
    },
    {
      key: "location",
      label: "Area",
      path: "/area-List",
      icon: (
        <CompassOutlined style={{ marginLeft: "1rem", fontSize: "20px" }} />
      ),
    },
    {
      key: "doctor",
      label: "Doctor",
      path: "/Doctor-List",
      icon: (
        <UserAddOutlined style={{ marginLeft: "1rem", fontSize: "20px" }} />
      ),
    },
    {
      key: "rolemanagement",
      label: "Role Management",
      path: "/roles-list",
      icon: <SettingOutlined style={{ fontSize: "20px" }} />,
    },
  ];

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.offsetHeight + "px");
    }

    const currentRoute = AllRoutes.find(
      (route) => route.path === location.pathname
    );
    if (currentRoute) {
      setSelectedKey(currentRoute.key);
    }
    const checkIfMobile = () => {
      setIsMobile(
        window.innerWidth <= 768 ||
          window.innerWidth <= 400 ||
          window.innerWidth < 1024
      );
    };
    checkIfMobile();
    window.addEventListener("resize", checkIfMobile);
    return () => window.removeEventListener("resize", checkIfMobile);
  }, [children, dataOfUser, userId, location, AllRoutes]);
  const fetchRoutes = useCallback(async () => {
    const userId = localStorage.getItem("userid");
    if (userId) {
      try {
        const response = await _get(
          `${API_BASE_URL}${Roles_list}${userId}`,
          directToken
        );
        const roles = response.data.list;
        setRolesData(roles);

        const filtered = filterRoutesByRoles(roles, AllRoutes);
        setFilteredRoutes(filtered);
      } catch (error) {
        console.error("Error fetching routes:", error);
      }
    }
  }, []);

  useEffect(() => {
    fetchRoutes();
  }, [fetchRoutes]);
  const handleNavigate = ({ key }) => {
    const route = AllRoutes.find((route) => route.key === key);
    if (route && route.path) {
      navigate(route.path);
      setSelectedKey(key);
    }
  };
  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const filterRoutesByRoles = (roles, AllRoutes) => {
    const isAdmin = roles.some((role) => role.userType === "Admin");
    if (isAdmin) {
      return AllRoutes;
    }
    const aggregatedPermissions = roles.reduce((acc, role) => {
      for (const [key, value] of Object.entries(role)) {
        if (value !== undefined) {
          acc[key] = value;
        }
      }
      return acc;
    }, {});
    return AllRoutes.filter((route) => {
      const routeKey = route.key;
      const routePermission = aggregatedPermissions[routeKey];
      const shouldIncludeRoute = routePermission === 1;

      return shouldIncludeRoute;
    });
  };

  const toggleDrawer = () => {
    setIsDrawerVisible(!isDrawerVisible);
  };
  const mapRoutesToMenuItems = (routes) => {
    return routes.map((route) => {
      return {
        key: route.key,
        icon: route.icon,
        label: route.label,
        onClick: () => handleNavigate({ key: route.key }),
      };
    });
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Menu: {
            itemSelectedBg: "#2748fcde",
            itemSelectedBg: "#6499f1  ",

            // itemSelectedBg: "white",
            itemSelectedColor: "white",
          },
          Table: {
            // headerBg: "#feccdc",
            headerBg: "#6499f1",

            headerSplitColor: "#6499f1",
            headerSortActiveBg: "#467ecf",
            // colorTextHeading: "white",
            colorTextHeading: "white",
          },
          Slider: {
            // controlSize: 3,
            dotActiveBorderColor: "black",
            handleLineWidthHover: "red",
            // dotSize: 10,
          },
          Popover: {
            titleMinWidth: "0px",
            borderRadiusLG: "1px",
          },
        },
      }}
    >
      <Layout>
        <Header
          style={{
            position: "sticky",
            top: 0,
            zIndex: 1000,
            width: "100%",
            boxShadow: "0 .5rem 1rem rgba(0,0,0,.15)",
            backgroundColor: "white",
            padding: 0,
          }}
          className="Box"
        >
          <Row
            style={{
              justifyContent: "space-between",
              flexWrap: "wrap",
            }}
            className="responsive-row"
          >
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                {isMobile ? (
                  <Button
                    size="small"
                    onClick={toggleDrawer}
                    icon={<MenuOutlined />}
                    className="mobile-menu-button"
                    style={{
                      backgroundColor: isMobile ? "white" : "#feccdc",
                      color: "black",
                    }}
                  />
                ) : (
                  <img
                    src={MyLogo}
                    alt="MyLogo"
                    style={{
                      width: "120px",
                      marginLeft: "2rem",
                      maxWidth: "100%",
                      maxHeight: "85px",
                    }}
                  />
                )}

                <div
                  style={{ display: "flex", alignItems: "center", gap: "1rem" }}
                >
                  {isMobile ? (
                    <Button
                      style={{
                        backgroundColor: "#6499f1",
                        color: "white",
                        width: "10rem",
                        height: "3rem",
                        fontSize: "20px",
                        borderRadius: "10px",
                        marginRight: "2rem",
                      }}
                      onClick={handleLogout}
                    >
                      Log out
                    </Button>
                  ) : (
                    <>
                      <Typography
                        style={{
                          fontSize: "16px",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Welcome{" "}
                        <span style={{ fontWeight: "500" }}>{Names}</span>
                      </Typography>
                      <Button
                        style={{
                          backgroundColor: "#6499f1",
                          color: "white",
                          width: "12rem",
                          marginTop: "5px",
                          height: "3rem",
                          fontWeight: "500",
                          fontSize: "16px",
                          borderRadius: "10px",
                          marginRight: "2rem",
                        }}
                        onClick={handleLogout}
                      >
                        Log out
                      </Button>
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Header>
      </Layout>
      <Layout>
        <Layout style={{ display: "flex" }}>
          <Sider
            style={{
              height: contentHeight,

              backgroundColor: "white",
              marginTop: "0.5%",

              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              marginLeft: "0.5%",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",

              // backgroundColor: "pink",
            }}
            breakpoint="md"
            collapsedWidth="0"
            width={230}
          >
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              style={{
                borderRight: 0,
                fontSize: "16px",
              }}
              items={mapRoutesToMenuItems(filteredRoutes)}
              onClick={handleNavigate}
            />
          </Sider>
          <Drawer
            title="Menu"
            placement="left"
            onClose={toggleDrawer}
            visible={isDrawerVisible}
            width={250}
          >
            <Menu
              mode="inline"
              selectedKeys={[selectedKey]}
              style={{
                borderRight: 0,
                overflowY: "auto",
                fontSize: "16px",
              }}
              items={mapRoutesToMenuItems(filteredRoutes)}
              onClick={handleNavigate}
            />
          </Drawer>
          <Layout style={{ flex: 1, marginLeft: "0.5rem" }}>
            <Content
              ref={contentRef}
              style={{
                marginTop: "0.5%",
              }}
            >
              {children}
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </ConfigProvider>
  );
};

export default DefaultLayout;
